import { useContext } from 'react';
import { Container } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import SearchBar from '../../../components/SearchBar';
import { AuthStore } from '../../../providers/auth';
import { ModalManagementStore } from '../../../providers/modal-manager';
import { DASHBOARD_ROUTE } from '../../../routes/types';
import { getAllFooterData } from '../../../services/navigation';
import { DateFormats, formatDate } from '../../../utils/utils';

const Footer = () => {
  const [, , , selectedPersona] = useContext(AuthStore) || [];
  const { openModal } = useContext(ModalManagementStore);
  const navigate = useNavigate();
  const footerMenus = getAllFooterData(selectedPersona);

  return (
    <Container fluid className="m-0 p-0 w-100 cnd-footer mt-12">
      <div className="first-section py-11 px-10 px-lg-11 w-100">
        <div className="d-flex flex-column flex-lg-row pt-1 justify-content-lg-between">
          <div
            className={'logo d-block'}
            onClick={() => navigate(DASHBOARD_ROUTE)}
          >
            <img
              src={`${process.env.PUBLIC_URL}/logo.png`}
              style={{ height: '60px' }}
            />
          </div>
          <div className="pt-12 pt-lg-0">
            <SearchBar placeholder="Search" />
          </div>
        </div>
        <div className="d-lg-flex flex-lg-row">
          {footerMenus.map((menu: any, i: number) => (
            <div
              key={i}
              className="links-section pt-12 text-sub1 fw-light d-flex flex-column col-lg-3"
            >
              <span
                className="fw-normal footer-title"
                style={{ height: 14 }}
              >
                {menu.title}
              </span>
              {menu.subMenus.map((subMenu: any, i: number) => (
                <div key={i} className="pt-3">
                  <span
                    className={`link ${!subMenu.url ? 'disabled' : ''}`}
                    onClick={() => {
                      if(subMenu.modal) {
                        openModal(subMenu.url);
                      }
                      else if(subMenu.target ==='_blank') {
                        window.open(subMenu.url)
                      }
                      else {
                        navigate(subMenu.url);
                      }
                    }}
                  >
                    {subMenu.title}
                  </span>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
      <div className="second-section py-11 px-10 px-lg-11 text-sub1 fw-light w-100 d-lg-flex flex-lg-row justify-content-lg-between">
        <div>
          <span>
            © {formatDate(new Date(), DateFormats.ONLY_YEAR)} Conduent Business
            Services, LLC All rights reserved.
          </span>
        </div>
        <div className="pt-10 pt-lg-0 d-flex flex-row">
          <div className="d-flex flex-column flex-lg-row">
            <span className="lh-xxs">Terms of Use</span>
            <span className="pt-3 pt-lg-0 ps-lg-10 lh-xxs">
              System Requirements
            </span>
          </div>
          <div className="ps-11 ps-lg-0 d-flex flex-column flex-lg-row">
            <span className="ps-lg-10 lh-xxs">Privacy Statement</span>
            <span className="pt-3 pt-lg-0 ps-lg-10 lh-xxs">Contact Us</span>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default Footer;
